export default "__VITE_ASSET__0VT2XEJE__"